import { useEffect, useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import DatePicker, { registerLocale } from "react-datepicker";
import { Button } from 'primereact/button';

/**
 * 
 * @param {*} props 
 * Props:
 * - vehicle
 * - startDate
 * - endDate
 * - onVehicleChange
 * - onStartDateChange
 * - onEndDateChange
 * - onSearchPress
 * @returns MaintenanceLogReportFilter
 */
function MaintenanceLogReportFilter(props) {
  const [vehicles, setVehicles] = useState([]);  
  const allVehiclesOption = {
    vehicleId: 0,
    description: '- Todos -'
  };

  // #region Events

  useEffect(() => {
    getVehicles();
  }, []);

  const onVehicleChange = (e) => {    
    if (props.onVehicleChange) props.onVehicleChange(e.value);
  };

  const onStartDateChange = (date) => {
    if (props.onStartDateChange) props.onStartDateChange(date);
  };

  const onEndDateChange = (date) => {
    if (props.onEndDateChange) props.onEndDateChange(date);
  };
  
  const onSearchPress = (date) => {
    if (props.onSearchPress) props.onSearchPress(date);
  };

  // #endregion

  // #region Methods

  const getVehicles = () => {    
    fetch(`${process.env.REACT_APP_API_URL}/vehicle/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        if (data.responseCode === 'OK') {          
          setVehicles([...[allVehiclesOption], ...data.responseObject]);
        } else {
          console.warn('Error getting vehicles', data);
        }                
      }, (error) => {
        console.error("Error getting vehicles", error);        
      });
  };

  // #endregion

  // #region Templates

  const filterTemplate = (
    <>
      <Row className='pb-2'>
        <Col sm={4}>
          Vehículo
        </Col>
        <Col sm={4}>
          Fecha inicial
        </Col>
        <Col sm={4}>
          Fecha final
        </Col>
      </Row>         
      <Row className='pb-2'>
        <Col sm={4}>          
          <Dropdown
            value={props.vehicle}
            options={vehicles}
            onChange={onVehicleChange}
            optionLabel="description"
            placeholder="Selecciona el vehículo"
            className='p-inputtext-sm w-100'
          />       
        </Col>
        <Col sm={4}>
          <DatePicker
            controlId="startDateInput"
            dateFormat="dd/MMM/yyyy"
            selected={props.startDate}
            onChange={onStartDateChange}
            selectsStart
            startDate={props.startDate}
            endDate={props.endDate}
            locale="es"
            className="w-100 app_datepicker"             
          />
        </Col>
        <Col sm={4}>
          <DatePicker
            controlId="endDateInput"
            dateFormat="dd/MMM/yyyy"
            selected={props.endDate}
            onChange={onEndDateChange}
            selectsEnd
            startDate={props.startDate}
            endDate={props.endDate}
            minDate={props.startDate}
            locale="es"
            className="w-100 app_datepicker"           
          />
        </Col>
      </Row> 
      <Row>
        <Col>
          <Button
            type="button"
            icon="pi pi-search"
            onClick={onSearchPress}
            className="p-button-raised p-button-sm p-button-primary"
            disabled={!props.vehicle || !props.startDate || !props.endDate}
            label='Buscar' />          
        </Col>
      </Row>

    </>
  );

  // #endregion

  return (
    <>
      {filterTemplate}
    </>
  );
}

export default MaintenanceLogReportFilter;